import ImageCarousel from "@/components/base/ImageCarousel";
import PriceDisplay from "@/components/base/PriceDisplay";

interface PurchaseOption {
  id: string;
  icon: string;
  label: string;
  subLabel: string;
  url: string;
  colorClass: string;
}

interface ProductCardItem {
  id: string;
  title: string;
  description: string;
  price: string;
  discounted_price?: string | null;
  image: string;
  images?: string[];
  category: string;
  badge?: string;
  purchaseOptions: PurchaseOption[];
}

interface ProductCardProps {
  product: ProductCardItem;
  onBuy: (product: ProductCardItem) => void;
}

const ProductCard = ({ product, onBuy }: ProductCardProps) => {
  const displayImages =
    product.images && product.images.length > 0
      ? product.images
      : product.image
      ? [product.image]
      : [];

  return (
    <div className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:-translate-y-1.5 transition-all duration-300 flex flex-col">
      {/* Image Carousel */}
      <div className="relative h-60 overflow-hidden">
        <ImageCarousel
          images={displayImages}
          alt={product.title}
          className="w-full h-full"
          showArrows
          showDots
        />

        {/* Hover overlay */}
        <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 z-20">
          <button
            onClick={() => onBuy(product)}
            className="px-5 py-2.5 rounded-full bg-white text-gray-900 text-sm font-semibold hover:bg-gradient-to-r hover:from-[#5FA8D3] hover:to-[#F78FB3] hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            View Options
          </button>
        </div>

        {product.badge && (
          <span className="absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-semibold text-white bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a] z-20">
            {product.badge}
          </span>
        )}
        <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-full text-xs font-medium text-white/90 bg-black/30 backdrop-blur-sm capitalize z-20">
          {product.category.replace("-", " ")}
        </span>
      </div>

      {/* Content */}
      <div className="p-5 flex flex-col flex-1">
        <h3
          className="font-semibold text-gray-900 text-base line-clamp-1 mb-1"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          {product.title}
        </h3>
        <p className="text-sm text-gray-500 line-clamp-2 mb-4 leading-relaxed flex-1">
          {product.description}
        </p>

        <div className="flex items-center justify-between mt-auto gap-2">
          <PriceDisplay price={product.price} discountedPrice={product.discounted_price} size="md" />
          <button
            onClick={() => onBuy(product)}
            className="px-4 py-2 rounded-full text-sm font-semibold text-white bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a] hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer"
          >
            Buy / View Options
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
